import flowRight from 'lodash/flowRight';

export const compose = flowRight; // eslint-disable-line
